module.exports = __webpack_public_path__ + "img/秒杀预告背景.ef0be849.png";